import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.saaspass-users.hard-token-users', {
        url: '/hard-token-users',
        component: 'companyUserDirectoriesSaaspassUsersHardTokenUsers',
        resolve: {
            companyUsers,
            hardTokens,
        },
    });
}

/** @ngInject */
function companyUsers(companyId, UsersResource) {
    return UsersResource.getAllRegularCompanyUsers(companyId, 'hardtoken');
}

/** @ngInject */
function hardTokens(HardTokenService) {
    return HardTokenService.list();
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/hard-token-users/hard-token-users.state.js